import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../empty/empty';

export class HeaderViewModel {
  currentViewer = ko.observable("empty-view");

  uploadHeader = (vm, evt) => {
    let file = evt.target.files[0];
    let reader = new FileReader();
    let extension = file.name.split('.').pop();
    if (extension.toLowerCase() !== "rtf")
    {
      alert("Falsches Format.")
    }
    else
    {
      reader.onload = ((f) => {

        return async (e) => {
            let base64Content = e.target.result.split(',')[1];
            let apiResult = await RNSAPI.uploadTextHeader(base64Content);
            if (apiResult.Type === "UploadSuccessful") {
                alert("Datei konnte erfolgreich hochgeladen werden.");
            }
            else{
                alert("Fehler beim hochladen.");
            }
        };
      })(file);
      reader.readAsDataURL(file);
    }
  }
}


let html = fs.readFileSync(__dirname + '/header.html', 'utf8');

ko.components.register("letterhead-upload-view", {
    viewModel: HeaderViewModel,
    template: html
});
